import * as zod from 'zod';

export const InvalidConfigurationState = zod.object({
  kind: zod.literal('InvalidConfiguration'),
});

export type InvalidConfigurationState = zod.infer<
  typeof InvalidConfigurationState
>;
